import { isValidIBAN } from 'ibantools';
export default function isValidIban(value) {
    return isValidIBAN(value);
}
